<template>
    <div>
        <div class="flex justify-end mb-5">
            <HotelDropdown
                :externalActions="true"
                @selectProperty="addFeature"
            />
        </div>
        <div class="flex flex-col">
            <div
                v-for="feature in features"
                :key="feature"
                class="grid grid-cols-12 gap-4 mb-2 pb-2 border-b last:border-0"
            >
                <div class="col-span-1">
                    <img
                        class="w-full max-w-32 h-auto rounded-lg"
                        :src="feature.image_location"
                        :alt="feature.name"
                    />
                </div>
                <div class="col-span-7 flex items-center">
                    <span class="text-sm text-semibold">
                        {{ feature.name }}
                    </span>
                </div>
                <div class="col-span-4 flex justify-end">
                    <button
                        class="text-red-700 hover:text-red-400 transition-colors"
                        @click="removeFeature(feature)"
                    >
                        <i class="fal fa-times"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { onMounted, ref } from 'vue';
import HotelDropdown from '@/components/hotels/search/search-form/hotel-dropdown.vue';

const features = ref([]);

const getFeaturedTools = () => {
    ApiService.apiCall(
        '/admin/settings/tools/',
        'get'
    ).then((response) => {
        features.value = response.data;
    });
};

const removeFeature = (feature) => {
    ApiService.apiCall(`/admin/settings/tools/${feature.id}/featured`, 'post', {
        featured: false,
    }).then((response) => {
        features.value.splice(features.value.indexOf(feature), 1);
    });
};

const addFeature = (feature) => {
    ApiService.apiCall(`/admin/settings/tools/${feature.id}/featured`, 'post', {
        featured: true,
    }).then((response) => {
        features.value.push(response.data);
    });
};

onMounted(() => {
    getFeaturedTools();
});
</script>
